module.exports = __webpack_public_path__ + "img/Rectangle 8.68917f93.svg";